import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowStretchBox20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowStretchBox20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 4.5h13a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1M1 5.5A2.5 2.5 0 0 1 3.5 3h13A2.5 2.5 0 0 1 19 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 14.5zm6.36 5.25 1.17 1.17a.75.75 0 0 1-1.06 1.06l-2.475-2.475-.53-.53.53-.53L7.47 6.97a.75.75 0 0 1 1.06 1.06L7.31 9.25h5.33l-1.17-1.17a.75.75 0 0 1 1.06-1.06l2.475 2.475.53.53-.53.53-2.475 2.475a.75.75 0 1 1-1.06-1.06l1.22-1.22z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowStretchBox20);
